module.exports = __webpack_public_path__ + "img/MFT白皮书_10.5eec282e.jpg";